<template>
  <div class="page-container">
    <div class="nav-container">
      <div v-for="tab in tabs" :key="tab.name" class="nav-item" :class="{ active: activeTabName === tab.name }"
        @click="handleTabClick(tab.name)">
        {{ tab.label }}
      </div>
    </div>
    <component :is="currentComponent" class="component-container"></component>
  </div>
</template>

<script setup>
import { ref, computed } from "vue"
// tabs对应的组件
import voltage from './voltage/index.vue'; // 电压一致性
import batteryCells from './batteryCells/index.vue'; // 电芯电压对比
import matrix from './matrix/index.vue'; // 方阵三项电压对比
import { useAppStore } from "@/store/modules/app";

const $str = window.$str;
const appStore = useAppStore()
const activeTabName = ref('a'); // 被激活的tab页对应的名称

const tabs = computed(() => [
  { name: 'a', label: $str.getKey('数据分析/电压一致性') },
  ...(appStore.hasEb100C ? [] : [
    { name: 'c', label: $str.getKey('数据分析/电芯电压对比') },
    { name: 'd', label: $str.getKey('数据分析/方阵三相电压对比') },
  ]),
])

const COMPONENTS = {
  a: voltage,
  c: batteryCells,
  d: matrix,
}

/** 计算动态组件当前渲染的组件 */
const currentComponent = computed(() => {
  return COMPONENTS[activeTabName.value];
})

function handleTabClick(name) {
  activeTabName.value = name
}

</script>
<style lang="scss" scoped>
.page-container {
  font-family: 'HarmonyOS Sans SC', sans-serif;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  .nav-container {
    padding: 0 14px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 1);
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .nav-item {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 20px;
    height: 44px;
    font-family: 'HarmonyOS Sans SC', sans-serif;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 100%;
    letter-spacing: 0%;
    color: rgba(46, 46, 46, 0.6);
    cursor: pointer;
    white-space: nowrap;
    transition: all 0.3s ease;
    border-radius: 20px;
    background: transparent;
    box-sizing: border-box;

    &:hover {
      color: rgba(46, 46, 46, 0.8);
      background: rgba(0, 0, 0, 0.02);
    }

    &.active {
      color: rgba(58, 104, 255, 1);
      font-weight: 400;
      background: rgba(226, 233, 255, 1);

      &::after {
        display: none;
      }
    }
  }

  .component-container {
    flex: 1;
    min-height: 0;
  }
}
</style>
